"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2025, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const RespondentBehaviorCharts_1 = require("../monitoring/RespondentBehaviorCharts");
const RespondentBehaviorPage = () => {
    // FIXME Experimental: This should be part of the monitoring page, not
    // loaded by default, but with loadable. But we keep it "hidden" for now,
    // until we are certain the metrics are correctly calculated and we can
    // trust the data shown.
    return (react_1.default.createElement("div", { className: "admin" },
        react_1.default.createElement("div", { className: "survey" },
            react_1.default.createElement("div", { className: "monitoring" },
                react_1.default.createElement(RespondentBehaviorCharts_1.RespondentBehaviorCharts, null)))));
};
exports.default = RespondentBehaviorPage;
//# sourceMappingURL=RespondentBehaviorPage.js.map